import React from 'react';
import { FunnelElement } from '../../types/element.types';
import { useFunnelStore } from '../../store/funnelStore';

interface AdvancedTabProps {
  element: FunnelElement;
}

/**
 * Advanced Tab Component
 * Allows editing advanced properties like custom CSS and animations
 */
const AdvancedTab: React.FC<AdvancedTabProps> = ({ element }) => {
  const { updateElementStyles } = useFunnelStore();

  const handleCustomCssChange = (value: string) => {
    updateElementStyles(element.id, { customCss: value });
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Custom CSS</h3>
        <p className="text-xs text-gray-600 mb-3">
          Add custom CSS properties. Each property should be on a new line.
        </p>
        <textarea
          value={element.styles.customCss || ''}
          onChange={(e) => handleCustomCssChange(e.target.value)}
          rows={10}
          placeholder="transform: rotate(5deg);&#10;transition: all 0.3s ease;"
          className="w-full px-3 py-2 text-sm font-mono border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>

      <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md">
        <p className="text-xs text-yellow-700">
          ⚠️ Custom CSS will override other style settings. Use with caution.
        </p>
      </div>

      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Element Info</h3>
        <div className="space-y-2 text-xs">
          <div className="flex justify-between">
            <span className="text-gray-600">Element ID:</span>
            <span className="font-mono text-gray-900">{element.id}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Element Type:</span>
            <span className="font-mono text-gray-900">{element.type}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedTab;

